if (!customElements.get('rt-image-mega-menu')) {
  customElements.define(
    'rt-image-mega-menu',
    class RTImageMegaMenu extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.controller = new AbortController();
        this.details = this.querySelector('[data-rt-image-menu-details]');
        this.summary = this.details?.querySelector(':scope > summary');
        this.tabs = Array.from(this.querySelectorAll('[data-rt-image-menu-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-rt-image-menu-panel]'));
        this.closeTimer = null;

        if (!this.details || !this.summary) return;

        const signal = this.controller.signal;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activateTab(tab), { signal });
          tab.addEventListener('mouseenter', () => this.activateTab(tab), { signal });
          tab.addEventListener('focus', () => this.activateTab(tab), { signal });
          tab.addEventListener('keydown', (event) => this.handleTabKeydown(event, index), { signal });
        });

        this.addEventListener('pointerenter', () => this.handlePointerEnter(), { signal });
        this.addEventListener('pointerleave', () => this.scheduleClose(), { signal });
        this.addEventListener('focusin', () => this.cancelClose(), { signal });
        this.addEventListener('focusout', (event) => this.handleFocusOut(event), { signal });
        this.details.addEventListener('toggle', () => this.syncExpandedState(), { signal });
        document.addEventListener('click', (event) => this.handleDocumentClick(event), { signal });
        document.addEventListener('keydown', (event) => this.handleDocumentKeydown(event), { signal });
        document.addEventListener('shopify:block:select', (event) => this.handleBlockSelect(event), { signal });
        document.addEventListener('shopify:block:deselect', (event) => this.handleBlockDeselect(event), { signal });

        this.syncExpandedState();
      }

      disconnectedCallback() {
        window.clearTimeout(this.closeTimer);
        this.controller?.abort();
        this.controller = null;
      }

      activateTab(activeTab) {
        const panelKey = activeTab.dataset.rtImageMenuTab;
        this.tabs.forEach((tab) => {
          const active = tab === activeTab;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          tab.closest('.rt-image-mega-menu__tab-row')?.classList.toggle('is-active', active);
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.rtImageMenuPanel !== panelKey;
        });
      }

      handleTabKeydown(event, index) {
        let nextIndex = index;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === index) return;
        event.preventDefault();
        this.tabs[nextIndex].focus();
      }

      handlePointerEnter() {
        this.cancelClose();
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) this.details.open = true;
      }

      handleFocusOut(event) {
        if (!this.contains(event.relatedTarget)) this.scheduleClose();
      }

      handleDocumentClick(event) {
        if (this.details.open && !this.contains(event.target)) this.closeMenu();
      }

      handleDocumentKeydown(event) {
        if (event.key !== 'Escape' || !this.details.open) return;
        event.preventDefault();
        this.closeMenu();
        this.summary.focus();
      }

      handleBlockSelect(event) {
        if (event.detail?.blockId !== this.dataset.blockId) return;
        this.details.open = true;
        this.cancelClose();
      }

      handleBlockDeselect(event) {
        if (event.detail?.blockId === this.dataset.blockId) this.closeMenu();
      }

      scheduleClose() {
        this.cancelClose();
        this.closeTimer = window.setTimeout(() => this.closeMenu(), 220);
      }

      cancelClose() {
        window.clearTimeout(this.closeTimer);
      }

      closeMenu() {
        this.cancelClose();
        this.details.open = false;
      }

      syncExpandedState() {
        this.summary.setAttribute('aria-expanded', String(this.details.open));
      }
    }
  );
}

if (!customElements.get('rt-mobile-image-menu')) {
  customElements.define(
    'rt-mobile-image-menu',
    class RTMobileImageMenu extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.addEventListener(
          'toggle',
          (event) => {
            const openedCategory = event.target;
            if (!(openedCategory instanceof HTMLDetailsElement) || !openedCategory.open) return;
            this.querySelectorAll('[data-rt-mobile-category]').forEach((category) => {
              if (category !== openedCategory) category.open = false;
            });
          },
          { capture: true, signal: this.controller.signal }
        );
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    }
  );
}
